import type { JSX } from 'react';
import { FormSection, Radio } from '@ksyos/design-system';
import type { BariPreNurseSpecialistMedScreeningReportData } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/types';
import { OperatieTypeWensOpties } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/bariPreNurseSpecialistMedScreeningReportData';
import { useProcessActivityEditContext } from '@frontend/utils';
import {
    BooleanRadioGroupFormGroup,
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '../../processActivityFormGroupFields';
import { YesNoWithConditionalTextAreaFormGroup } from '../../YesNoWithConditionalTextAreaFormGroup';
import { sortedOperatieTypeWensOpties } from './bariPreNurseSpecialistMedScreeningReportUtils';

export function BariPreNurseSpecialistMedScreeningReportConclusie(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPreNurseSpecialistMedScreeningReportData>();

    return (
        <FormSection title="Conclusie">
            <RadioGroupFormGroup
                fieldKey="wens_voor_type_operatie"
                isRequired={true}
                label="Wens patiënt voor type operatie"
                onChange={handleChangeWensVoorTypeOperatie}
            >
                {sortedOperatieTypeWensOpties.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
            {data.wens_voor_type_operatie === OperatieTypeWensOpties.anders && (
                <TextAreaFormGroup
                    fieldKey="wens_voor_type_operatie_anders_toelichting"
                    isRequired={true}
                    label="Toelichting ander type operatie"
                />
            )}
            <YesNoWithConditionalTextAreaFormGroup
                fieldKey="contra_indicatie"
                fieldValue={data.contra_indicatie}
                isRequired={true}
                label="Contra-indicatie voor een maagverkleinende operatie"
                textAreaFieldKey="contra_indicatie_toelichting"
                textAreaLabel="Toelichting contra-indicatie"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="dagbehandeling"
                isRequired={true}
                label="Geschikt voor dagbehandeling"
                onChange={handleChangeDagbehandeling}
                tooltipText="Exclusiecriteria dagbehandeling: BMI >50, IDDM, antistolling, cardiovasculair risico, psychisch kwetsbaar of taalbarrière"
                type="radio"
            />
            {data.dagbehandeling === false && (
                <TextAreaFormGroup
                    fieldKey="dagbehandeling_toelichting"
                    isRequired={true}
                    label="Toelichting dagbehandeling"
                />
            )}
        </FormSection>
    );

    async function handleChangeDagbehandeling(value: boolean | null): Promise<void> {
        return onChange(
            {
                dagbehandeling: value,
                dagbehandeling_toelichting: null,
            },
            'dagbehandeling'
        );
    }

    async function handleChangeWensVoorTypeOperatie(value: string | null): Promise<void> {
        return onChange(
            {
                wens_voor_type_operatie: value as OperatieTypeWensOpties,
                wens_voor_type_operatie_anders_toelichting: null,
            },
            'wens_voor_type_operatie'
        );
    }
}
